var TECL_TenderCompletion = {

    // Initialise the page
    Initialise: function() {
        TECL_TenderGeneral.HidePleaseWaitDlg();

        window.scrollTo(0, 0);

        // Update the progress bar
        TECL_TenderGeneral.UpdateProgressBar(4);
        TECL_TenderGeneral.InitialiseStickySidebar();
    },

    // Print the tender
    ShowTenderReport: function() {
        var cacheId = $("#cacheId").val();
        window.open(baseSiteUrl + "umbraco/Surface/Tender/DownloadReportFile?cacheId=" + cacheId, '_blank');
    },

    // Goto home page
    RedirectToHome: function() {
        window.location = baseSiteUrl;
    },

    // Create a new tender
    CreateNewTender: function() {
        if (TECL_Master.AddLock("ResetToFirstPage")) {
            // Call Server to add the product request to the cache and reload the product request list
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/Tender/ResetToFirstPage",
                type: "POST",
                error: function(exc) {
                    TECL_Master.ClearLock("ResetToFirstPage");
                },
                success: function(partialViewHtml) {
                    TECL_Master.ClearLock("ResetToFirstPage");
                    if (partialViewHtml) {
                        $("#tenderPage").html(partialViewHtml);
                    }
                }
            });
        }
    }

};